import { format } from "date-fns/format";
import { isValid } from "date-fns/isValid";
import { parse } from "date-fns/parse";
const FORM_DATE_FORMAT = 'yyyyMMdd';
const FORM_TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;
const CALENDAR_DATE_PREFIX = /^(\d{4}-\d{2}-\d{2})/;
function normalizeToFormDateString(date) {
    if (!date) return '';
    const trimmed = date.trim();
    if (/^\d{8}$/.test(trimmed)) {
        const parsed = parse(trimmed, FORM_DATE_FORMAT, new Date());
        return isValid(parsed) ? trimmed : '';
    }
    const calendarMatch = CALENDAR_DATE_PREFIX.exec(trimmed);
    const dashed = calendarMatch?.[1];
    if (dashed) {
        const parsed = parse(dashed, 'yyyy-MM-dd', new Date());
        if (isValid(parsed) && format(parsed, 'yyyy-MM-dd') === dashed) return format(parsed, FORM_DATE_FORMAT);
    }
    return '';
}
function normalizeToFormTimeString(time, fallback = '10:00') {
    if (!time) return fallback;
    const trimmed = time.trim();
    return FORM_TIME_PATTERN.test(trimmed) ? trimmed : fallback;
}
function parseFormDateString(date, referenceDate = new Date()) {
    if (!date) return;
    const normalized = normalizeToFormDateString(date);
    if (!normalized) return;
    const parsed = parse(normalized, FORM_DATE_FORMAT, referenceDate);
    return isValid(parsed) ? parsed : void 0;
}
function getDateRangeFromFormDates(startDate, endDate, referenceDate = new Date()) {
    const from = parseFormDateString(startDate, referenceDate);
    if (!from) return;
    const to = parseFormDateString(endDate, referenceDate);
    return to ? {
        from,
        to
    } : {
        from
    };
}
function handleSingleDateCalendarChange(setValue, watchLabel, setDefaultMonth, date) {
    const formattedDate = format(date, 'yyyyMMdd');
    setValue(watchLabel, formattedDate);
    setDefaultMonth(date);
}
function handleDateRangeCalendarChange(setValue, watchStartLabel, watchEndLabel, setDefaultMonth, dates, options = {}) {
    const setDirtyValue = (name, value)=>{
        if (options.shouldDirty) return void setValue(name, value, {
            shouldDirty: true
        });
        setValue(name, value);
    };
    if (dates?.from) {
        const startDate = format(dates.from, 'yyyyMMdd');
        setDirtyValue(watchStartLabel, startDate);
        setDefaultMonth(dates.from);
        if (options.clearEndDateOnStart) setDirtyValue(watchEndLabel, '');
    }
    if (dates?.to) {
        const endDate = format(dates.to, 'yyyyMMdd');
        setDirtyValue(watchEndLabel, endDate);
    } else if (dates?.from && !options.clearEndDateOnStart) setDirtyValue(watchEndLabel, '');
}
const isString = (value)=>'string' == typeof value;
export { getDateRangeFromFormDates, handleDateRangeCalendarChange, handleSingleDateCalendarChange, isString, normalizeToFormDateString, normalizeToFormTimeString, parseFormDateString };
